// Tujuh tombol overlay Windy. Nol state MapService, makanya ditaruh di luar.
export function wireWindyControls({
  picker, store, overlays, broadcast,
}) {
  document.getElementById('toggle-btn').addEventListener('click', () => {
    picker.close();
    document.getElementById('button-container').classList.toggle('hidden');
  });

  // Initialize numDirection
  store.set('numDirection', false);
  let numDirection = store.get('numDirection');
  document.getElementById('btn-num-direction').addEventListener('click', (button) => {
    picker.close();
    numDirection = !numDirection;
    store.set('numDirection', numDirection);
    button.target.innerText = `${numDirection ? 'on' : 'off'}`;
  });

  // Initialize graticule
  store.set('graticule', false);
  let graticule = store.get('graticule');
  document.getElementById('btn-graticule').addEventListener('click', (button) => {
    graticule = !graticule;
    store.set('graticule', graticule);
    button.target.innerText = `${graticule ? 'on' : 'off'}`;
  });

  // Initialize latlon
  store.set('latlon', true);
  let latlon = store.get('latlon');
  document.getElementById('btn-latlon').addEventListener('click', (button) => {
    picker.close();
    latlon = !latlon;
    store.set('latlon', latlon);
    button.target.innerText = `${latlon ? 'on' : 'off'}`;
  });

  // Initialize particlesAnim
  store.set('particlesAnim', 'on');
  const availableParticlesAnim = store.getAllowed('particlesAnim');
  let particlesAnim = store.get('particlesAnim');
  document.getElementById('btn-particles-anim').addEventListener('click', (button) => {
    const idx = availableParticlesAnim.indexOf(particlesAnim);
    particlesAnim = availableParticlesAnim[(idx + 1) % availableParticlesAnim.length];
    store.set('particlesAnim', particlesAnim);
    button.target.innerText = `${particlesAnim}`;
  });

  // Initialize isolines
  store.set('isolines', 'off');
  const availableIsolines = store.getAllowed('isolines');
  let isolines = store.get('isolines');
  document.getElementById('btn-isolines').addEventListener('click', (button) => {
    const idx = availableIsolines.indexOf(isolines);
    isolines = availableIsolines[(idx + 1) % availableIsolines.length];
    store.set('isolines', isolines);
    button.target.innerText = `${isolines}`;
  });

  let currentOverlay = 'wind';

  broadcast.on('redrawFinished', (params) => {
    currentOverlay = params.overlay;
    document.getElementById('btn-metric').innerText = `${overlays[currentOverlay].metric}`;
  });

  document.getElementById('btn-metric').addEventListener('click', (button) => {
    picker.close();
    overlays[currentOverlay].cycleMetric();
    button.target.innerText = `${overlays[currentOverlay].metric}`;
  });
}

export default wireWindyControls;
